import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { DashBoardService } from 'src/app/service/dash-board.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styles: []
})
export class DashBoardComponent implements OnInit {
    constructor(
        private dashBoardService: DashBoardService,
        private toastr: ToastrService,
        public datePipe: DatePipe,
    ) { }

    datas: any[] = [];
    dataChart: any[] = [];
    initDataChart: any[] = [];

    users: any[] = [];
    myControl = new FormControl('');
    filteredOptions: Observable<any[]>;

    dateControlEnd = new FormControl(new Date());
    dateControlStart = new FormControl(new Date());

    month = new Date().getMonth() + 1;
    yearMonth = new Date().getFullYear();
    
    year = new Date().getFullYear();

    type: number = 1;

    ngOnInit() {
        this.loadListFilterUser();
    }

    displayFn(user: any): string {
        return user && user.userName ? user.userName + (user.fullName ? ' - ' + user.fullName : '') : '';
    }

    private _filter(filter: string): any[] {
        const filterValue = filter.toLowerCase();

        return this.users.filter(option => option.userName.toLowerCase().includes(filterValue));
    }

    loadListFilterUser() {
        this.dashBoardService.getListFilterUser().subscribe(
            res => {
                this.users = <any>res;

                this.filteredOptions = this.myControl.valueChanges.pipe(
                    startWith(''),
                    map(value => {
                        const filter = typeof value === 'string' ? value : (value ? value.filter : null);
                        return filter ? this._filter(filter as string) : this.users.slice();
                    }),
                );
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    loadData() {
        document.getElementById('page-loader-data').style.display = "block";
        let params = {
            "userName": this.myControl && this.myControl.value ? this.myControl.value.userName : "",
            "startDateInput": this.datePipe.transform(this.dateControlStart.value, 'yyyy-MM-dd'),
            "endDateInput": this.datePipe.transform(this.dateControlEnd.value, 'yyyy-MM-dd'),
            "month": this.month,
            "yearMonth": this.yearMonth,
            "year": this.year,
            "type": this.type
        };
        this.dashBoardService.getRevenueByUser(params).subscribe(
            res => {
                this.datas = <any>res;

                this.dataChart = [];
                for (var i = 0; i < this.datas.length; i++) {
                    let data = this.datas[i];
                    switch (this.type) {
                        // Ngày
                        case 1:
                            const existsType1 = this.dataChart.find(x => x.name == data.vnpTransDateString);
                            if (existsType1) {
                                existsType1.series.find(x => x.name == "Sale Price").value += data.vnpAmount;
                                existsType1.series.find(x => x.name == "Return Amount").value += data.returnAmount;
                            }
                            else {
                                this.dataChart.push({
                                    name: data.vnpTransDateString,
                                    series: [
                                        {
                                            "name": "Sale Price",
                                            "value": data.vnpAmount
                                        },
                                        {
                                            "name": "Return Amount",
                                            "value": data.returnAmount
                                        }
                                    ]
                                });
                            }
                            break;

                        // Tháng
                        case 2:
                            const existsType2 = this.dataChart.find(x => x.name == data.month + "/" + data.year);
                            if (existsType2) {
                                existsType2.series.find(x => x.name == "Sale Price").value += data.vnpAmount;
                                existsType2.series.find(x => x.name == "Return Amount").value += data.returnAmount;
                            }
                            else {
                                this.dataChart.push({
                                    name: data.month + "/" + data.year,
                                    series: [
                                        {
                                            "name": "Sale Price",
                                            "value": data.vnpAmount
                                        },
                                        {
                                            "name": "Return Amount",
                                            "value": data.returnAmount
                                        }
                                    ]
                                });
                            }
                            break;

                        // Năm
                        case 3:
                            const existsType3 = this.dataChart.find(x => x.name == data.year.toString());
                            if (existsType3) {
                                existsType3.series.find(x => x.name == "Sale Price").value += data.vnpAmount;
                                existsType3.series.find(x => x.name == "Return Amount").value += data.returnAmount;
                            }
                            else {
                                this.dataChart.push({
                                    name: data.year.toString(),
                                    series: [
                                        {
                                            "name": "Sale Price",
                                            "value": data.vnpAmount
                                        },
                                        {
                                            "name": "Return Amount",
                                            "value": data.returnAmount
                                        }
                                    ]
                                });
                            }
                            break;
                    }
                }

                this.initDataChart = JSON.parse(JSON.stringify(this.dataChart));
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    tabChanged(tab) {
        this.type = tab.index + 1;
    }

    onSelect(event) {
        if (this.isLegend(event)) {
            if (this.isDataShown(event)) {
                const tempData = JSON.parse(JSON.stringify(this.dataChart));
                tempData.forEach(country => {
                    country.series.forEach(year => {
                        if (year.name === event) {
                            year.value = 0;
                        }
                    });
                });
                this.dataChart = tempData;
            } else {
                this.initDataChart.forEach(country => {
                    country.series.forEach(year => {
                        if (year.name === event && year.value !== 0) {
                            this.setChartDataBackToInitData(country.name, year.name, year.value)
                        }
                    });
                });
            }
        }
    }

    isLegend = (event) => typeof event === 'string';

    isDataShown = (event) => {
        const selectedBar = this.dataChart.find(model => {
            return model.series.find(singleModel => {
                return singleModel.name === event && singleModel.value !== 0;
            });
        });

        return typeof selectedBar !== 'undefined';
    }

    setChartDataBackToInitData = (country, yearName, yearDefValue) => {
        const tempData = JSON.parse(JSON.stringify(this.dataChart));
        tempData.find(_country => _country.name === country).series.find(_year => _year.name === yearName).value = yearDefValue;
        this.dataChart = tempData;
    }
}